import { Location } from '@app/shared/routes';

const incidentLocation = new Location({
  path: '/care-management/incidents'
});

export { incidentLocation };
